import dayjs from "dayjs";

const weekday = require("dayjs/plugin/weekday");
const weekOfYear = require("dayjs/plugin/weekOfYear");
const isBetween = require("dayjs/plugin/isBetween");

const calendar = require('./helpers/calendar');
const bookingForm = require('./helpers/bookingForm');
const promoCode = require('./helpers/promoCode');
const bookingBasket = require('./helpers/bookingBasket');
const constants = require('./utils/constants');

dayjs.extend(weekday);
dayjs.extend(weekOfYear);
dayjs.extend(isBetween);


const CALENDAR_ELEMENT = calendar.buildCalendar('balloon-flight-booking-app');

bookingBasket.mountBookingBasketIfNeeded();

promoCode.initPromoCodeHook();

CALENDAR_ELEMENT.addEventListener('fetchData', (event) => {
    calendar.updateNumberOfPassengers(event.detail.passengers);
    calendar.updateQuickReleaseData();
});

document.getElementById('booking-form').addEventListener('submit', (event) => {
    bookingForm.validateBookingForm(event);
});
